import type { BuilderStep, BuilderCampaignSnapshot, ChannelConfig, StepCompletion } from "../config";

export const BUILDER_STEPS: BuilderStep[] = ["targeting", "design", "tracking"];

export interface StepState {
  completion: StepCompletion;
  reachable: Record<BuilderStep, boolean>;
  currentStep: BuilderStep;
}

export const deriveStepState = (
  campaign: BuilderCampaignSnapshot,
  config: ChannelConfig,
  // Merged over the config-derived completion. Lets a step fold in gating that
  // depends on runtime state the campaign snapshot doesn't carry (e.g. the
  // Targeting min/max distributor gate, F8).
  completionOverride?: Partial<StepCompletion>
): StepState => {
  const completion = { ...config.getStepCompletion(campaign), ...completionOverride };

  const reachable = {} as Record<BuilderStep, boolean>;
  let priorComplete = true;
  BUILDER_STEPS.forEach((step) => {
    reachable[step] = priorComplete;
    priorComplete = priorComplete && completion[step];
  });

  const currentStep = BUILDER_STEPS.find((step) => !completion[step]) ?? BUILDER_STEPS[BUILDER_STEPS.length - 1];

  return { completion, reachable, currentStep };
};
